import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { ArrowLeft, Construction, Clock } from 'lucide-react';

const serviceNames = {
  'gesamtabsolvierungen': 'Gesamtabsolvierungen',
  'bereinigung_teams': 'Bereinigung Teams',
};

const serviceDescriptions = {
  'gesamtabsolvierungen': 'Report über absolvierte Kurse im eMatrixsys',
  'bereinigung_teams': 'Teams-Bereinigung im eMatrixsys',
};

const ServicePlaceholder = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  
  const serviceName = serviceNames[serviceId] || 'Service';
  const serviceDescription = serviceDescriptions[serviceId] || 'Dieser Service wird in Kürze verfügbar sein.';

  return (
    <Layout>
      <div className="space-y-6 animate-fade-in">
        {/* Header */}
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate('/dashboard')} data-testid="back-button">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold">{serviceName}</h1>
            <p className="text-muted-foreground mt-1">{serviceDescription}</p>
          </div>
        </div>

        {/* Coming Soon Card */}
        <Card className="max-w-2xl mx-auto">
          <CardHeader className="text-center">
            <div className="w-20 h-20 mx-auto bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Construction className="h-10 w-10 text-primary" />
            </div>
            <CardTitle className="text-2xl">In Entwicklung</CardTitle>
            <CardDescription className="text-base">
              Dieser Service wird derzeit entwickelt und ist bald verfügbar.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center">
            <div className="flex items-center justify-center gap-2 text-muted-foreground">
              <Clock className="h-4 w-4" />
              <span>Details folgen in Kürze</span>
            </div>
            <Button 
              variant="outline" 
              className="mt-6"
              onClick={() => navigate('/dashboard')}
              data-testid="back-to-dashboard"
            >
              Zurück zum Dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default ServicePlaceholder;
